
import React from "react";
import { motion } from "framer-motion";
import { AlertCircle } from "lucide-react";
import Layout from "../components/Layout";
import ActionButton from "../components/ActionButton";
import { Card, CardContent } from "@/components/ui/card";

const errors = {
  'kev-001': {
    title: "An error occurred",
    icon: <AlertCircle className="h-20 w-20 text-red-500" />,
    description: "We couldn't get the minimum information needed to create your video. Please try again with a different URL.",
    actionText: "Try with a different URL",
    actionLink: "/"
  },
  default: {
    title: "An error occurred",
    icon: <AlertCircle className="h-20 w-20" />,
    description: "Something went wrong. Please try again later.",
    actionText: "Start again",
    actionLink: "/"
  }
};

const Error = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const errorCode = urlParams.get('e') || 'default';
  const error = errors[errorCode] || errors.default;

  return (
    <Layout>
      <motion.div
        className="text-center py-16 space-y-8"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.5 }}
      >
        <Card className="glass border-none overflow-hidden">
          <CardContent className="p-10 flex flex-col items-center space-y-6">
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.5 }}
              className="flex justify-center text-muted-foreground"
            >
              {error.icon}
            </motion.div>

            <motion.div
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.4, duration: 0.5 }}
            >
              <h1 className="text-4xl font-bold mb-4">{error.title}</h1>
              <p className="text-muted-foreground max-w-md mx-auto mb-8">
                {error.description}
              </p>
            </motion.div>

            <div>
              <ActionButton to={error.actionLink}>
                {error.actionText}
              </ActionButton>
            </div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.6, duration: 0.5 }}
              className="pt-8 border-t border-border mt-4 w-full"
            >
              <p className="text-sm text-muted-foreground">Error Code: {errorCode.toUpperCase()}</p>
            </motion.div>
          </CardContent>
        </Card>
      </motion.div>
    </Layout>
  );
};

export default Error;
